module.exports = __webpack_public_path__ + "static/img/ios_tw.9d08b5f5.png";